module.exports = __webpack_public_path__ + "img/safie.ca411a7a.png";